
export enum RoleType {
  CM3 = "CM3",
  PM = "PM",
  CCM1 = "CCM1",
  CCM2 = "CCM2",
  CCM3 = "CCM3",
  CCM3Manager = "CCM3-Manager",
  DCCM = "DCCM",
  SPM = "SPM",
  DCCM_Review = "DCCM-Review",
  SPM_Review = "SPM-Review",
  DM_Review = "DM-Review",
  VP_Review = "VP-Review",
  Ops = "Ops",
  Payroll = "Payroll",
  Admin = "Admin",
  VP = "VP-Review",
  DM = "DM-Review",
}

export const RoleRouteMapping: Record<RoleType, Record<string, string>> = {
  [RoleType.CM3]: { "CM3": "/CM3-PM" },
  [RoleType.PM]: { "PM": "/CM3-PM" },
  [RoleType.CCM1]: { "CCM": "/CCM" },
  [RoleType.CCM2]: { "CCM": "/CCM" },
  [RoleType.CCM3]: { "CCM": "/CCM" },
  [RoleType.CCM3Manager]: { "DCCM": "/DCCM" },
  [RoleType.DCCM]: { "DCCM": "/DCCM", "CCM": "/CCM" },
  [RoleType.SPM]: { "SPM": "/SPM", "CM3": "/CM3-PM", "PM": "/CM3-PM" },
  [RoleType.DCCM_Review]: { "CCM": "/CCM" },
  [RoleType.SPM_Review]: { "CM3": "/CM3-PM", "PM": "/CM3-PM" },
  [RoleType.DM_Review]: { "CM3": "/CM3-PM", "PM": "/CM3-PM", "SPM": "/SPM" },
  [RoleType.VP_Review]: { "CM3": "/CM3-PM", "PM": "/CM3-PM", "SPM": "/SPM", "CCM": "/CCM", "DCCM": "/DCCM" },
  [RoleType.Ops]: { "CM3": "/CM3-PM", "PM": "/CM3-PM", "SPM": "/SPM", "CCM": "/CCM", "DCCM": "/DCCM", "ops": "/admin/dashboard/status-overview"},
  [RoleType.Payroll]: { "CM3": "/CM3-PM", "PM": "/CM3-PM", "SPM": "/SPM", "CCM": "/CCM", "DCCM": "/DCCM" },
  [RoleType.Admin]: { "admin": "/admin/dashboard/status-overview" },
};

export const AdminRoutes = {
  // Dashboard
  DASHBOARD_CURRENT_STATUS: "/admin/dashboard/status-overview",
  
  // Manage
  MANAGE_HIERARCHY_OVERRIDES: "/admin/manage/employee-hierarchy-overrides",
  MANAGE_REVIEWERS: "/admin/manage/reviewers",
  MANAGE_STATUS_FLOW: "/admin/manage/status-flow",
} as const;

// Helper function to get the route with ID
export const getRouteWithId = (
  roleType: RoleType,
  id: string | number,
  appType: string = "CCM"
): string => {
  const baseRoute = RoleRouteMapping[roleType]?.[appType];
  return baseRoute ? `${baseRoute}/${id}` : "";
};

// Helper function to check if a user has admin access
export const hasAdminRole = (userRoles: string[]): boolean => {
  return ["Admin", "Ops"].some(role => userRoles.includes(role));
};